import Login from "../components/login.components";

const LoginPage = () => {
  return (
    <Login/>
  )
}

export default LoginPage;